import { Target, Heart, Lightbulb } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const OurStory = () => {
  return (
    <section id="our-story" className="py-24 md:py-32 bg-secondary/50">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Text Content */}
          <div>
            <span className="text-accent font-semibold text-sm uppercase tracking-widest mb-4 block">
              Our Story
            </span>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-4 leading-tight">
              Learning That Lasts. <br />Rewards That Motivate. 🎓💰
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed mb-6">
              TERALEARN was born from a student solving a problem every learner faces — scattered 
              tutorials, lost notes, and no single place to track progress. So we built a platform 
              where you don't just learn — you earn.
            </p>
            <Link to="/our-story">
              <Button variant="outline" className="gap-2">
                Read Our Full Story <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </div>

          {/* Values Cards */}
          <div className="flex flex-col gap-6">
            <div className="bg-card border border-border/60 rounded-2xl p-6 shadow-sm">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
                  <Target className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground text-lg mb-1">Our Mission</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Make learning skills and knowledge accessible to every Nigerian student — without expensive fees or scattered resources.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-card border border-border/60 rounded-2xl p-6 shadow-sm">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center shrink-0">
                  <Heart className="w-6 h-6 text-accent" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground text-lg mb-1">Our Values</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Accessibility, integrity, and community. Built by learners, for learners — no corporate BS.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-card border border-border/60 rounded-2xl p-6 shadow-sm">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
                  <Lightbulb className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground text-lg mb-1">Our Vision</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    The go-to platform for any Nigerian who wants to learn a skill — easier, faster, and rewarding.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurStory;
